import { createSelector } from "@ngrx/store";
import { storeSelector } from "../store.selector";

export const tokenSelector = createSelector(
  storeSelector,
  store => store?.token
);

export const GuardSelector = createSelector(
  storeSelector,
  store => store?.user?.token
);

